module.exports = __webpack_public_path__ + "img/iphone13.2da79c97.svg";